import { render, staticRenderFns } from "./indexCommunity.vue?vue&type=template&id=4e8f4a6c&scoped=true"
import script from "./indexCommunity.vue?vue&type=script&lang=js"
export * from "./indexCommunity.vue?vue&type=script&lang=js"
import style0 from "./indexCommunity.vue?vue&type=style&index=0&id=4e8f4a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f4a6c",
  null
  
)

export default component.exports